import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Shadows } from '../../theme/modules/shadows';
import { colors } from '../../theme/modules/colors';
import { sizes } from '../../theme/modules/sizes';
import { radius } from '../../theme/modules/radius';
import { text } from '../../theme/modules/text';
const { grey } = colors.neutral;
const elevationShadowMap = {
    0: 'none',
    1: Shadows.sm,
    2: Shadows.base,
    3: Shadows.md,
    4: Shadows.lg,
};
const accents = {
    info: colors.secondary.blue.base,
    success: colors.secondary.green.base,
    error: colors.secondary.red.base,
};
export const Footer = styled.footer.withConfig({ displayName: "vui--Footer", componentId: "vui--livrdi" }) `margin-top:${sizes.base};padding:${sizes.md};z-index:2;`;
export const Section = styled.section.withConfig({ displayName: "vui--Section", componentId: "vui--z99ese" }) `padding-right:${sizes.md};padding-left:${sizes.md};margin-top:${sizes.md};margin-bottom:${sizes.md};font-family:${text.body.fontFamily};font-size:${text.body.fontSize};font-weight:${text.body.fontWeight};line-height:${text.body.lineHeight};color:${text.body.color};& + &{border-top:${sizes.line} solid ${grey.base};padding-top:${sizes.md};}`;
export const FullBleed = styled.div.withConfig({ displayName: "vui--FullBleed", componentId: "vui--1lgjeo7" }) `margin-left:-${sizes.md};margin-right:-${sizes.md};`;
export const Body = styled(motion.div).withConfig({ displayName: "vui--Body", componentId: "vui--pfgeh3" }) `overflow-y:hidden;&:not(:first-child)> ${Section}:first-child{margin-top:0;}`;
export const Surface = styled.div.withConfig({ displayName: "vui--Surface", componentId: "vui--g1wpqa" }) `position:relative;width:100%;background-color:white;border:${sizes.line} solid ${grey.base};box-shadow:${(props) => props.elevation !== undefined ? elevationShadowMap[props.elevation] : Shadows.sm};border-radius:${radius.md};overflow:hidden;box-sizing:border-box;${({ accent }) => accent &&
    `
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: ${sizes.xs};
      background-color: ${accents[accent]};
    }
  `}`;
//# sourceMappingURL=styled.js.map